import { render, staticRenderFns } from "./RelatoriosAutocomplete.vue?vue&type=template&id=7228d29c&scoped=true"
import script from "./RelatoriosAutocomplete.vue?vue&type=script&lang=js"
export * from "./RelatoriosAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228d29c",
  null
  
)

export default component.exports